import React from "react";
import { View, StyleSheet } from "react-native";

interface ProgressBarProps {
  percentage: number;
  size?: "sm" | "md" | "lg";
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, size = "sm" }) => {
  const height = size === "sm" ? 6 : size === "md" ? 8 : 12;
  const progressColor = "#3B82F6"; // blue

  return (
    <View style={styles.progressContainer}>
      <View style={[styles.progressBackground, { height }]}>
        <View
          style={[
            styles.progressFill,
            {
              height,
              width: `${Math.max(0, Math.min(percentage, 100))}%`,
              backgroundColor: progressColor,
            },
          ]}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  progressContainer: {
    marginBottom: 4,
  },
  progressBackground: {
    backgroundColor: "#E5E7EB",
    borderRadius: 3,
    overflow: "hidden",
  },
  progressFill: {
    borderRadius: 3,
  },
});

export default ProgressBar;
